import { MDBRow } from "mdb-react-ui-kit";
import styles from "@/styles/auth/Auth.module.scss";
import { useRouter } from "next/router";
import { useStore } from "@/store/index";

const AuthPolicyAndTerms = () => {
    const router = useRouter();
    const dispatch = useStore(state => state.dispatchAuth);

    const closeModal = () => {
        dispatch({
            type: "RESET_AUTH",
        });
    };

    const handleClick = (href: string) => {
        closeModal();
        router.push(href);
    };

    const downloadFileAtURL = (url: string | undefined, fileName: string) => {
        if (url) {
            // Usa fetch invece di axios per evitare l'interceptor che aggiunge X-Currency
            // L'header X-Currency può causare problemi con il download di file statici da CloudFront
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(
                            `HTTP error! status: ${response.status}`
                        );
                    }
                    return response.blob();
                })
                .then(blob => {
                    const blobURL = window.URL.createObjectURL(blob);
                    const aTag = document.createElement("a");
                    aTag.href = blobURL;
                    aTag.setAttribute("download", fileName);
                    document.body.appendChild(aTag);
                    aTag.click();
                    aTag.remove();
                    // Pulisci l'URL dopo il download
                    window.URL.revokeObjectURL(blobURL);
                })
                .catch(error => {
                    console.error("Error downloading file:", error);
                });
        }
    };

    return (
        <MDBRow className="g-0 w-100 text-center">
            <p className={styles.infoText}>
                By logging into my PlayItaly account, I accept the{" "}
                <span
                    className={`d-inline-flex ${styles.infoTextLinks}`}
                    onClick={() => handleClick("/info/privacy")}
                >
                    Privacy Policy
                </span>{" "}
                and the{" "}
                <span
                    className={`d-inline-flex ${styles.infoTextLinks}`}
                    onClick={() =>
                        downloadFileAtURL(
                            "https://d3t4iiwihaed0b.cloudfront.net/terms-condition/Terms_Conditions.pdf",
                            "Terms & Conditions"
                        )
                    }
                >
                    terms and conditions
                </span>{" "}
                of Play Italy
            </p>
        </MDBRow>
    );
};

export default AuthPolicyAndTerms;
